import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import * as React from 'react';
function ExpandableSection({ children, maxHeight = 240, 
// expandButtonLabel = ss.i18n._t('SupplyPageShow.EXPAND_SHOW_ALL'),
expandButtonLabel = 'Alle gegevens tonen', }) {
    const contentRef = React.useRef(null);
    const [isExpandable, setIsExpandable] = React.useState(false); // Is the content higher then MAX_HEIGHT?
    const [isExpanded, setIsExpanded] = React.useState(false); // Has the user triggered the expand action?
    React.useLayoutEffect(() => {
        if (contentRef.current) {
            setIsExpandable(contentRef.current.offsetHeight > maxHeight);
        }
    }, []);
    const expandableStyles = {
        maxHeight: maxHeight,
        overflow: 'hidden',
    };
    return (_jsxs("div", { children: [_jsx("div", { ref: contentRef, className: "expandable-box", style: isExpandable && !isExpanded ? expandableStyles : {}, children: children }), isExpandable && !isExpanded ? (_jsx("button", { onClick: () => setIsExpanded(true), className: "button", type: "button", children: `${expandButtonLabel}` })) : null] }));
}
export { ExpandableSection };
